import React, { useState } from 'react';
import { HiOutlineMenuAlt3, HiX } from "react-icons/hi";
import { Link } from 'react-router-dom';
import Logo from '../images/Logo.png';
import Word from '../images/Wordmark.png';
import { IoIosCloseCircleOutline } from "react-icons/io";
import ContactForm from '../components/ContactForm';
import Blogs from '../images/Blogs.png';
import Bot from '../images/bot.png';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false); // State to track menu open/close
  const [whatsappPopup, setWhatsappPopup] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen); // Toggle menu state
  };

  const closeMenu = () => {
    setIsMenuOpen(false); // Close menu
  };

  const [showPopup, setShowPopup] = useState(false);
  const [launchShowPopup, setLaunchShowPopup] = useState(false);

  const showWhatsappPopup = () => {
    setWhatsappPopup(!whatsappPopup);
  };

  const handleOrderButtonClick = () => {
    // Commented out whatsapp navigation logic
    // const screenWidth = window.innerWidth;
    // if (screenWidth > 768) {
    //   showWhatsappPopup();
    // } else {
    //   window.location.href = 'https://wa.me/message/5TJSEZZBZM5LM1';
    // }
    window.open('https://falhari.order.food-pe.com/', '_blank', 'noopener,noreferrer');
  };

  const LaunchingPopup = () => {
    setLaunchShowPopup(!launchShowPopup);
  };

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  return (
    <nav className="z-50 fixed bg-white w-full border-b shadow-sm">
      <div className="container mx-auto flex justify-between items-center px-4 lg:px-12 h-16 relative">
        <Link to="/" className="text-black font-bold text-lg flex items-center">
          <img className='w-10 h-10 object-contain' src={Logo} alt="Logo" />
          <img className='w-24 h-10 object-contain pl-2' src={Word} alt="Wordmark" />
        </Link>
        {/* Toggle button for mobile */}
        <button
          onClick={toggleMenu}
          className="lg:hidden text-gray-800 p-2 focus:outline-none rounded-lg hover:bg-gray-100 transition"
          aria-label="Toggle Menu"
        >
          {isMenuOpen ? (
            <HiX className="h-7 w-7 text-[#FF410B]" />
          ) : (
            <HiOutlineMenuAlt3 className="h-7 w-7 text-gray-800" />
          )}
        </button>
        {/* Mobile sidebar menu */}
        <div
          className={`lg:hidden absolute top-full left-0 right-0 w-full bg-white/95 backdrop-blur-md border-b shadow-xl transition-all duration-300 ease-in-out transform ${isMenuOpen ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 -translate-y-4 pointer-events-none'}`}
        >
          <div className="p-6 text-black w-full flex flex-col justify-center space-y-4">
            <ul className="flex flex-col space-y-2 font-semibold text-center">
              <li>
                <Link to="/" onClick={closeMenu} className="block py-2 text-gray-800 hover:text-[#FF410B] transition">Home</Link>
              </li>
              <li>
                <Link to="/corporate" onClick={closeMenu} className="block py-2 text-gray-800 hover:text-[#FF410B] transition">Corporate</Link>
              </li>
              <li>
                <Link to="/blogs" onClick={closeMenu} className="block py-2 text-gray-800 hover:text-[#FF410B] transition">Blogs</Link>
              </li>
              <li>
                <Link to="/contactus" onClick={closeMenu} className="block py-2 text-gray-800 hover:text-[#FF410B] transition">Contact Us</Link>
              </li>
            </ul>
            <div className="pt-2 flex flex-col space-y-3">
              <button 
                onClick={() => { togglePopup(); closeMenu(); }} 
                className="w-full py-2.5 border-2 border-black rounded-full font-semibold text-black hover:bg-[#FF410B] hover:text-white hover:border-[#FF410B] transition"
              >
                Schedule Meet
              </button>
              <a
                href="https://falhari.order.food-pe.com/"
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeMenu}
                className="w-full py-2.5 text-center text-white bg-[#FF410B] hover:bg-[#e03709] font-semibold rounded-full shadow-md transition inline-block"
              >
                Order Online
              </a>
            </div>
          </div>
        </div>
        {/* Desktop navigation */}
        <ul className="hidden lg:flex items-center space-x-6">
          <li>
            <Link to="/" className="text-black font-semibold hover:text-[#FF410B] transition">Home</Link>
          </li>
          <li>
            <Link to="/corporate" className="text-black font-semibold hover:text-[#FF410B] transition">Corporate</Link>
          </li>
          <li>
            <Link to="/blogs" className="text-black font-semibold hover:text-[#FF410B] transition">Blogs</Link>
          </li>
          <li>
            <Link to="/contactus" className="text-black font-semibold hover:text-[#FF410B] transition">Contact Us</Link>
          </li>
          <li onClick={togglePopup}>
            <Link to="#" className="text-black border px-6 py-2 border-2 border-black rounded-full font-semibold hover:bg-[#FF410B] hover:text-white hover:border-[#FF410B] transition">Schedule Meet</Link>
          </li>
          <li>
            <a
              href="https://falhari.order.food-pe.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white border px-5 py-2 bg-[#FF410B] hover:bg-[#e03709] font-semibold rounded-full inline-block transition shadow"
            >
              Order Online
            </a>
          </li>
        </ul>

        {showPopup && (
          <div className="popup-wrapper">
            <div className="popup-content">
              <IoIosCloseCircleOutline className="close-icon" onClick={togglePopup} />
              <ContactForm />
            </div>
          </div>
        )}

        {launchShowPopup && (
          <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-4 rounded w-2/5">
              <IoIosCloseCircleOutline className="close-icon absolute top-0 right-0 mt-2 mr-2 cursor-pointer text-white font-bold text-2xl" onClick={LaunchingPopup} />
              <img className='w-5/6 m-auto' src={Blogs} alt="Launching Soon" />
              <p className='text-3xl font-bold'>Launching Soon</p>
              <p className='text-xl font-medium'>Stay tuned</p>
              <button className='bg-[#FF410B] px-4 py-2 text-white text-semibold rounded' onClick={LaunchingPopup}>OK</button>
            </div>
          </div>
        )}

        {whatsappPopup && (
          <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-4 rounded w-2/5">
              <IoIosCloseCircleOutline className="close-icon absolute top-0 right-0 mt-2 mr-2 cursor-pointer text-black font-bold text-2xl" onClick={showWhatsappPopup} />
              <img className='w-4/6 m-auto object-cover' src={Bot} alt="Ordering Made Easy Bot" />
              <p className='text-xl font-bold'>Ordering Made Easy</p>
              <p className='text-3xl font-bold'>Order Online</p>
              <a href="https://falhari.order.food-pe.com/" target="_blank" rel="noopener noreferrer">
                <button className='bg-[#FF410B] px-4 py-2 text-white text-semibold rounded w-full mt-2'>Order Now</button>
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
